<template>
  <v-dialog persistent v-model="show" max-width="770px">
    <v-card>
      <v-btn icon class="btn-cancelar-flotante" @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-card-title>
        <div class="headline">{{ bajaMode ? 'Crear Baja' : 'Crear Ausencia' }}</div>
      </v-card-title>

      <hr class="header-separator" />

      <v-card-text>
        <v-expand-transition>
          <div v-show="!editandoHora">
            <v-container>
              <v-row dense>
                <v-col cols="12" class="py-2">
                  <div class="campo-label campo-label-compacto">{{ bajaMode ? 'Tipo de Baja' : 'Tipo de Ausencia' }} <span class="required-asterisk">*</span></div>
                  <v-select
                    v-model="form.type"
                    :items="filteredTiposAusencia"
                    :placeholder="bajaMode ? 'Seleccione el tipo de baja' : 'Seleccione el tipo de ausencia'"
                    class="campo-redondeado campo-compacto"
                    :class="{ 'campo-error': validationErrors.type }"
                    solo
                    :error-messages="validationErrors.type ? [validationErrors.type] : []"
                    required
                    dense
                  ></v-select>
                  <div v-if="isMatrimonioBaja" class="info-dias-baja">
                    15 días naturales
                  </div>
                  <div v-if="isFallecimiento1Grado" class="info-dias-baja">
                    4 días laborables
                  </div>
                  <div v-if="isFallecimiento2Grado" class="info-dias-baja">
                    2 días laborables
                  </div>
                  <div v-if="isTrasladoDomicilio" class="info-dias-baja">
                    1 día
                  </div>
                  <div v-if="isPermisoClimatico" class="info-dias-baja">
                    4 días
                  </div>
                  <div v-if="isEnfermedadGraveFamiliar2Grado" class="info-dias-baja">
                    5 días discontinuos - Organizarse con RRHH
                  </div>
                  <div v-if="isDeberInexcusable || isFuncionesSindicales || isNacimientoCuidadoMenor || isDonacionOrganos" class="info-dias-baja">
                    Indefinido - Establecer fecha fin
                  </div>
                </v-col>

                <v-col cols="12">
                  <div class="campo-label">
                    {{ bajaMode || isBaja ? 'Anotaciones' : 'Motivo' }}
                    <span v-if="!(bajaMode || isBaja)" class="required-asterisk">*</span>
                    <span v-else style="color: #888; font-size: 12px;">(Opcional)</span>
                  </div>
                  <v-text-field
                    v-model="form.reason"
                    :placeholder="(bajaMode || isBaja) ? 'Añade cualquier detalle o anotación adicional' : 'Escriba el motivo de su ausencia'"
                    class="campo-redondeado"
                    :class="{ 'campo-error': validationErrors.reason }"
                    solo
                    :error-messages="validationErrors.reason ? [validationErrors.reason] : []"
                    :required="!(bajaMode || isBaja)"
                  ></v-text-field>
                </v-col>

                <!-- Campos de hora solo para ausencias normales -->
                <v-col cols="4" v-if="!bajaMode">
                  <div class="campo-label">Hora Inicio <span class="required-asterisk">*</span></div>
                  <v-text-field
                    v-model="form.startTime"
                    readonly
                    class="campo-redondeado"
                    :class="{ 'campo-error': validationErrors.startTime }"
                    solo
                    :error-messages="validationErrors.startTime ? [validationErrors.startTime] : []"
                    @click="openTimePicker('start')"
                  ></v-text-field>
                </v-col>

                <v-col cols="4" v-if="!bajaMode">
                  <div class="campo-label">Hora Fin <span class="required-asterisk">*</span></div>
                  <v-text-field
                    v-model="form.endTime"
                    readonly
                    class="campo-redondeado"
                    :class="{ 'campo-error': validationErrors.endTime }"
                    solo
                    :error-messages="validationErrors.endTime ? [validationErrors.endTime] : []"
                    @click="openTimePicker('end')"
                  ></v-text-field>
                </v-col>

                <!-- Fecha de inicio -->
                <v-col :cols="bajaMode ? 6 : 4">
                  <div class="campo-label">
                    {{ bajaMode ? 'Día de Inicio' : 'Fecha' }} <span class="required-asterisk">*</span>
                  </div>
                  <v-menu
                    v-model="datePickerMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.date"
                        placeholder="DD/MM/YYYY"
                        class="campo-redondeado"
                        :class="{ 'campo-error': validationErrors.date }"
                        solo
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        prepend-inner-icon="mdi-calendar"
                        :error-messages="validationErrors.date ? [validationErrors.date] : []"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="datePickerValue"
                      @input="onDateSelected"
                      :first-day-of-week="1"
                      locale="es"
                      no-title
                      scrollable
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <!-- Fecha de fin solo para bajas -->
                <v-col cols="6" v-if="bajaMode">
                  <div class="campo-label">
                    Día de Fin <span class="required-asterisk">*</span>
                  </div>
                  <v-menu
                    v-model="endDatePickerMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    :disabled="isIndefinidaBaja"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="displayEndDate"
                        placeholder="DD/MM/YYYY"
                        class="campo-redondeado"
                        :class="{ 'campo-error': validationErrors.endDate, 'campo-indefinido': isIndefinidaBaja }"
                        solo
                        readonly
                        v-bind="attrs"
                        v-on="isIndefinidaBaja ? {} : on"
                        prepend-inner-icon="mdi-calendar"
                        :error-messages="validationErrors.endDate ? [validationErrors.endDate] : []"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endDatePickerValue"
                      @input="onEndDateSelected"
                      :first-day-of-week="1"
                      locale="es"
                      no-title
                      scrollable
                      :min="datePickerValue"
                      :readonly="isMatrimonioBaja || isFallecimiento1Grado || isFallecimiento2Grado || isTrasladoDomicilio || isPermisoClimatico"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12">
                <div class="campo-label">
                  Justificante PDF
                  <span v-if="isBaja" class="required-asterisk">*</span>
                  <span v-else>(Opcional)</span>
                </div>
                <v-file-input
                  v-model="form.fotoJustificante"
                  placeholder="Seleccione un archivo PDF"
                  class="campo-redondeado"
                  :class="{ 'campo-error': validationErrors.fotoJustificante }"
                  :hide-details="!validationErrors.fotoJustificante"
                  solo
                  accept="application/pdf"
                  prepend-icon=""
                  prepend-inner-icon="mdi-file-pdf"
                  show-size
                  :error-messages="validationErrors.fotoJustificante ? [validationErrors.fotoJustificante] : []"
                ></v-file-input>
              </v-col>
              </v-row>
            </v-container>
          </div>
        </v-expand-transition>

        <v-expand-transition>
          <div v-show="editandoHora" class="modo-edicion-hora">
            <div class="rectangulo-edicion">
              <div class="hora-body">
                <v-time-picker
                  v-model="currentTimePicker"
                  format="24hr"
                  full-width
                  class="selector-hora"
                />
              </div>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="btn-fondo1" @click="cerrarEdicionHora">Aceptar</v-btn>
                <v-btn class="btn-fondo1" @click="cancelarEdicionHora">Cancelar</v-btn>
              </v-card-actions>
              <hr class="header-separator" />
            </div>
          </div>
        </v-expand-transition>
      </v-card-text>

      <v-card-actions class="justify-center" v-if="!editandoHora">
        <v-btn class="btn-fondo" @click="save">Guardar</v-btn>
      </v-card-actions>
    </v-card>

    <!-- Dialog de error -->
    <v-dialog v-model="errorDialog.show" max-width="500px">
      <v-card>
        <v-card-title class="error-dialog-header">
          <v-icon color="white" large left>mdi-alert-circle</v-icon>
          <span class="error-dialog-title">Error al crear ausencia</span>
        </v-card-title>

        <v-card-text class="error-dialog-content">
          <div class="error-icon-wrapper">
            <v-icon color="error" size="60">mdi-alert-circle-outline</v-icon>
          </div>
          <div class="error-message">
            {{ errorDialog.message }}
          </div>
          <div v-if="errorDialog.details" class="error-details">
            {{ errorDialog.details }}
          </div>
        </v-card-text>

        <v-card-actions class="error-dialog-actions">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="errorDialog.show = false">
            Entendido
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar para errores -->
    <v-snackbar
      v-model="snackbar.visible"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      <b>{{ snackbar.text }}</b>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import { Absence } from "../domain/Absence";
import { AbsenceValidator } from "../domain/AbsenceValidator";
import { v4 as uuidv4 } from "uuid";
import { client } from '@/api/client';

export default {
  name: "UpdateAbsencePopup",
  props: {
    show: Boolean,
    absence: Object,
    preselectedDate: Date,
    existingAbsences: {
      type: Array,
      default: () => []
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    companydbId: {
      type: [Number, String],
      default: null
    },
    bajaMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tiposAusencia: [],
      loadingTipos: false,
      tiposBaja: [
        'Matrimonio (o registro pareja de hecho)',
        'Enfermedad grave familiar 2º grado',
        'Fallecimiento familiar 1º grado (padre, hijos, cónyuge, pareja de hecho)',
        'Fallecimiento familiar 2º grado (hermanos, abuelos, nietos, suegros, cuñados)',
        'Traslado domicilio habitual',
        'Cumplimiento deber inexcusable (votar, declararse jurado...)',
        'Funciones sindicales o de representación del personal',
        'Nacimiento y cuidado del menor (exámenes prenatales, preparación al parto, adopción/acogimiento)',
        'Permiso climático',
        'Donación de órganos o tejidos',
        'Otros'
      ],
      form: {
        type: null,
        reason: "",
        startTime: "",
        endTime: "",
        date: "",
        endDate: "",
        fotoJustificante: null
      },
      editandoHora: false,
      currentTimePicker: "",
      currentTimeField: null, // 'start' o 'end'
      datePickerMenu: false,
      datePickerValue: null,
      endDatePickerMenu: false,
      endDatePickerValue: null,
      errorDialog: {
        show: false,
        message: '',
        details: ''
      },
      validationErrors: {
        type: '',
        reason: '',
        startTime: '',
        endTime: '',
        date: '',
        endDate: '',
        fotoJustificante: ''
      },
      snackbar: {
        visible: false,
        text: '',
        color: 'error',
        timeout: 3000
      }
    };
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.loadAbsenceTypes();
        this.initializeForm();
      }
    },
    preselectedDate() {
      if (this.show) {
        this.initializeForm();
      }
    },
    companydbId(newVal, oldVal) {
      // Recargar tipos de ausencia cuando cambie la empresa
      if (newVal !== oldVal && this.show) {
        this.loadAbsenceTypes();
      }
    },
    'form.type'(newVal) {
      // Cuando se selecciona "Baja", establecer horas a 00:00-23:59 para todo el día
      if (newVal === 'Baja') {
        this.form.startTime = '00:00';
        this.form.endTime = '23:59';
      }

      // Si es baja de matrimonio y ya hay fecha de inicio seleccionada, ajustar fecha fin automáticamente
      if (newVal && newVal.includes('Matrimonio') && this.form.date) {
        const dateParts = this.form.date.split('/');
        if (dateParts.length === 3) {
          const day = parseInt(dateParts[0]);
          const month = parseInt(dateParts[1]);
          const year = parseInt(dateParts[2]);

          const startDate = new Date(year, month - 1, day);
          const endDate = new Date(startDate);
          endDate.setDate(endDate.getDate() + 14); // 14 días después (15 días en total)

          const endYear = endDate.getFullYear();
          const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
          const endDay = String(endDate.getDate()).padStart(2, '0');

          this.form.endDate = endDay + '/' + endMonth + '/' + endYear;
          this.endDatePickerValue = endYear + '-' + endMonth + '-' + endDay;
        }
      }

      // Si es fallecimiento 1º grado y ya hay fecha de inicio seleccionada, ajustar fecha fin automáticamente
      if (newVal && newVal.includes('Fallecimiento familiar 1º grado') && this.form.date) {
        const dateParts = this.form.date.split('/');
        if (dateParts.length === 3) {
          const day = parseInt(dateParts[0]);
          const month = parseInt(dateParts[1]);
          const year = parseInt(dateParts[2]);

          const startDate = new Date(year, month - 1, day);
          const endDate = this.addBusinessDays(startDate, 3); // 3 días laborables después (4 en total)

          const endYear = endDate.getFullYear();
          const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
          const endDay = String(endDate.getDate()).padStart(2, '0');

          this.form.endDate = endDay + '/' + endMonth + '/' + endYear;
          this.endDatePickerValue = endYear + '-' + endMonth + '-' + endDay;
        }
      }

      // Si es fallecimiento 2º grado y ya hay fecha de inicio seleccionada, ajustar fecha fin automáticamente
      if (newVal && newVal.includes('Fallecimiento familiar 2º grado') && this.form.date) {
        const dateParts = this.form.date.split('/');
        if (dateParts.length === 3) {
          const day = parseInt(dateParts[0]);
          const month = parseInt(dateParts[1]);
          const year = parseInt(dateParts[2]);

          const startDate = new Date(year, month - 1, day);
          const endDate = this.addBusinessDays(startDate, 1); // 1 día laborable después (2 en total)

          const endYear = endDate.getFullYear();
          const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
          const endDay = String(endDate.getDate()).padStart(2, '0');

          this.form.endDate = endDay + '/' + endMonth + '/' + endYear;
          this.endDatePickerValue = endYear + '-' + endMonth + '-' + endDay;
        }
      }

      // Si es traslado de domicilio y ya hay fecha de inicio seleccionada, ajustar fecha fin automáticamente (mismo día)
      if (newVal && newVal.includes('Traslado domicilio habitual') && this.form.date) {
        const dateParts = this.form.date.split('/');
        if (dateParts.length === 3) {
          const day = String(dateParts[0]).padStart(2, '0');
          const month = String(dateParts[1]).padStart(2, '0');
          const year = dateParts[2];

          this.form.endDate = day + '/' + month + '/' + year;
          this.endDatePickerValue = year + '-' + month + '-' + day;
        }
      }

      // Si es permiso climático y ya hay fecha de inicio seleccionada, ajustar fecha fin automáticamente
      if (newVal && newVal.includes('Permiso climático') && this.form.date) {
        const dateParts = this.form.date.split('/');
        if (dateParts.length === 3) {
          const day = parseInt(dateParts[0]);
          const month = parseInt(dateParts[1]);
          const year = parseInt(dateParts[2]);

          const startDate = new Date(year, month - 1, day);
          const endDate = new Date(startDate);
          endDate.setDate(endDate.getDate() + 3); // 3 días después (4 días en total)

          const endYear = endDate.getFullYear();
          const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
          const endDay = String(endDate.getDate()).padStart(2, '0');

          this.form.endDate = endDay + '/' + endMonth + '/' + endYear;
          this.endDatePickerValue = endYear + '-' + endMonth + '-' + endDay;
        }
      }

      // Si es uno de los tipos indefinidos y ya hay fecha de inicio, establecer 1 año después
      if ((newVal && (newVal.includes('Cumplimiento deber inexcusable') ||
                      newVal.includes('Funciones sindicales') ||
                      newVal.includes('Nacimiento y cuidado del menor') ||
                      newVal.includes('Donación de órganos'))) && this.form.date) {
        const dateParts = this.form.date.split('/');
        if (dateParts.length === 3) {
          const day = parseInt(dateParts[0]);
          const month = parseInt(dateParts[1]);
          const year = parseInt(dateParts[2]);

          const startDate = new Date(year, month - 1, day);
          const endDate = new Date(startDate);
          endDate.setFullYear(endDate.getFullYear() + 1); // 1 año después

          const endYear = endDate.getFullYear();
          const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
          const endDay = String(endDate.getDate()).padStart(2, '0');

          this.form.endDate = endDay + '/' + endMonth + '/' + endYear;
          this.endDatePickerValue = endYear + '-' + endMonth + '-' + endDay;
        }
      }
    }
  },
  mounted() {
    this.loadAbsenceTypes();
    this.initializeForm();
  },
  computed: {
    companydb_id() {
      // Priorizar la prop companydbId si se proporciona
      if (this.companydbId) {
        return parseInt(this.companydbId);
      }
      // Obtener companydb_id de la ruta o del usuario
      if (this.$route && this.$route.params && this.$route.params.companydb_id) {
        return parseInt(this.$route.params.companydb_id);
      }
      // Obtener del store si está disponible
      if (this.$store && this.$store.getters) {
        const userData = this.$store.getters['me/userData'];
        if (userData && userData.company_id) {
          return parseInt(userData.company_id);
        }
      }
      return null;
    },
    isBaja() {
      return this.form.type && this.form.type.startsWith('Baja:');
    },
    isMatrimonioBaja() {
      return this.form.type && this.form.type.includes('Matrimonio');
    },
    isFallecimiento1Grado() {
      return this.form.type && this.form.type.includes('Fallecimiento familiar 1º grado');
    },
    isFallecimiento2Grado() {
      return this.form.type && this.form.type.includes('Fallecimiento familiar 2º grado');
    },
    isTrasladoDomicilio() {
      return this.form.type && this.form.type.includes('Traslado domicilio habitual');
    },
    isPermisoClimatico() {
      return this.form.type && this.form.type.includes('Permiso climático');
    },
    isEnfermedadGraveFamiliar2Grado() {
      return this.form.type && this.form.type.includes('Enfermedad grave familiar 2º grado');
    },
    isDeberInexcusable() {
      return this.form.type && this.form.type.includes('Cumplimiento deber inexcusable');
    },
    isFuncionesSindicales() {
      return this.form.type && this.form.type.includes('Funciones sindicales');
    },
    isNacimientoCuidadoMenor() {
      return this.form.type && this.form.type.includes('Nacimiento y cuidado del menor');
    },
    isDonacionOrganos() {
      return this.form.type && this.form.type.includes('Donación de órganos');
    },
    isIndefinidaBaja() {
      return this.isDeberInexcusable || this.isFuncionesSindicales || this.isNacimientoCuidadoMenor || this.isDonacionOrganos;
    },
    displayEndDate() {
      // Si es una baja indefinida, mostrar "Indefinida" en lugar de la fecha
      if (this.isIndefinidaBaja) {
        return 'Indefinida';
      }
      return this.form.endDate;
    },
    filteredTiposAusencia() {
      if (this.bajaMode) {
        // En modo baja, solo mostrar tipos que empiecen con "Baja:"
        return this.tiposAusencia.filter(tipo => tipo.startsWith('Baja:'));
      } else {
        // En modo normal, filtrar todos los tipos que empiecen con "Baja:"
        return this.tiposAusencia.filter(tipo => !tipo.startsWith('Baja:'));
      }
    }
  },
  methods: {
    // Función auxiliar para calcular días laborables (excluyendo sábados y domingos)
    addBusinessDays(startDate, daysToAdd) {
      const date = new Date(startDate);
      let daysAdded = 0;

      while (daysAdded < daysToAdd) {
        date.setDate(date.getDate() + 1);
        // 0 = domingo, 6 = sábado
        if (date.getDay() !== 0 && date.getDay() !== 6) {
          daysAdded++;
        }
      }

      return date;
    },

    // Función para contar días laborables entre dos fechas (incluyendo ambas fechas)
    countBusinessDays(startDate, endDate) {
      let count = 0;
      const current = new Date(startDate);
      current.setHours(0, 0, 0, 0);
      const end = new Date(endDate);
      end.setHours(0, 0, 0, 0);

      // Contar todos los días laborables incluyendo inicio y fin
      while (current <= end) {
        // 0 = domingo, 6 = sábado
        if (current.getDay() !== 0 && current.getDay() !== 6) {
          count++;
        }
        current.setDate(current.getDate() + 1);
      }

      return count;
    },

    async loadAbsenceTypes() {
      // Tipos de baja con prefijo
      const tiposBajaCompletos = this.tiposBaja.map(tipo => `Baja: ${tipo}`);

      if (!this.companydb_id) {
        // Si no hay companydb_id, usar los valores por defecto
        this.tiposAusencia = [...tiposBajaCompletos, 'Médico', 'Personal', 'Familiar', 'Trámite', 'Otros'];
        return;
      }

      this.loadingTipos = true;
      try {
        const response = await client.get('/companydb/' + this.companydb_id + '/absence-reasons/');
        const reasons = response.data.absence_reasons || [];

        // Si hay motivos configurados, usarlos; si no, usar los por defecto
        if (reasons.length > 0) {
          // Añadir todos los tipos de baja al principio, luego los motivos personalizados
          this.tiposAusencia = [...tiposBajaCompletos, ...reasons.filter(r => !r.startsWith('Baja:'))];
        } else {
          this.tiposAusencia = [...tiposBajaCompletos, 'Médico', 'Personal', 'Familiar', 'Trámite', 'Otros'];
        }
      } catch (error) {
        console.error('Error al cargar tipos de ausencia:', error);
        // En caso de error, usar los valores por defecto
        this.tiposAusencia = [...tiposBajaCompletos, 'Médico', 'Personal', 'Familiar', 'Trámite', 'Otros'];
      } finally {
        this.loadingTipos = false;
      }
    },
    initializeForm() {
      const dateToUse = this.getInitialDate();

      function pad(n) {
        return n < 10 ? "0" + n : n;
      }

      this.form = {
        type: (this.absence && this.absence.type) ? this.absence.type : null,
        reason: (this.absence && this.absence.reason) ? this.absence.reason : "",
        startTime: this.absence ?
          this.formatTimeFromDate(new Date(this.absence.start)) :
          (this.bajaMode ? '00:00' : pad(dateToUse.getHours()) + ":" + pad(dateToUse.getMinutes())),
        endTime: this.absence ?
          this.formatTimeFromDate(new Date(this.absence.end)) :
          (this.bajaMode ? '23:59' : pad(dateToUse.getHours()) + ":" + pad(dateToUse.getMinutes())),
        date: this.absence ?
          this.formatDateFromDate(new Date(this.absence.start)) :
          pad(dateToUse.getDate()) + "/" + pad(dateToUse.getMonth() + 1) + "/" + dateToUse.getFullYear(),
        endDate: this.absence ?
          this.formatDateFromDate(new Date(this.absence.end)) :
          pad(dateToUse.getDate()) + "/" + pad(dateToUse.getMonth() + 1) + "/" + dateToUse.getFullYear(),
        fotoJustificante: null
      };

      // Establecer datePickerValue en formato YYYY-MM-DD para el date picker
      const year = dateToUse.getFullYear();
      const month = pad(dateToUse.getMonth() + 1);
      const day = pad(dateToUse.getDate());
      this.datePickerValue = year + '-' + month + '-' + day;
      this.endDatePickerValue = year + '-' + month + '-' + day;

      // Limpiar errores de validación al inicializar
      this.validationErrors = {
        type: '',
        reason: '',
        startTime: '',
        endTime: '',
        date: '',
        endDate: '',
        fotoJustificante: ''
      };
    },

    getInitialDate() {
      if (this.preselectedDate) {
        return new Date(this.preselectedDate);
      }
      if (this.absence) {
        return new Date(this.absence.start);
      }
      return new Date();
    },

    formatTimeFromDate(date) {
      function pad(n) {
        return n < 10 ? "0" + n : n;
      }
      return pad(date.getHours()) + ":" + pad(date.getMinutes());
    },

    formatDateFromDate(date) {
      function pad(n) {
        return n < 10 ? "0" + n : n;
      }
      return pad(date.getDate()) + "/" + pad(date.getMonth() + 1) + "/" + date.getFullYear();
    },

    showWithDate(date) {
      this.selectedDate = date;
      this.visible = true;
    },

    onDateSelected(date) {
      // date viene en formato YYYY-MM-DD del date picker
      // Convertir a DD/MM/YYYY
      const parts = date.split('-');
      const year = parts[0];
      const month = parts[1];
      const day = parts[2];
      this.form.date = day + '/' + month + '/' + year;
      this.datePickerMenu = false;

      // Limpiar error de validación si existe
      if (this.validationErrors.date) {
        this.validationErrors.date = '';
      }

      // Si es baja de matrimonio, ajustar automáticamente la fecha fin a 15 días después
      if (this.isMatrimonioBaja) {
        const startDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        const endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + 14); // 14 días después (15 días en total incluyendo el día de inicio)

        const endYear = endDate.getFullYear();
        const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
        const endDay = String(endDate.getDate()).padStart(2, '0');

        this.form.endDate = endDay + '/' + endMonth + '/' + endYear;
        this.endDatePickerValue = endYear + '-' + endMonth + '-' + endDay;
      }

      // Si es fallecimiento 1º grado, ajustar automáticamente la fecha fin a 4 días laborables después
      if (this.isFallecimiento1Grado) {
        const startDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        // Calcular 3 días laborables después (4 días laborables totales incluyendo el día de inicio)
        const endDate = this.addBusinessDays(startDate, 3);

        const endYear = endDate.getFullYear();
        const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
        const endDay = String(endDate.getDate()).padStart(2, '0');

        this.form.endDate = endDay + '/' + endMonth + '/' + endYear;
        this.endDatePickerValue = endYear + '-' + endMonth + '-' + endDay;
      }

      // Si es fallecimiento 2º grado, ajustar automáticamente la fecha fin a 2 días laborables después
      if (this.isFallecimiento2Grado) {
        const startDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        // Calcular 1 día laborable después (2 días laborables totales incluyendo el día de inicio)
        const endDate = this.addBusinessDays(startDate, 1);

        const endYear = endDate.getFullYear();
        const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
        const endDay = String(endDate.getDate()).padStart(2, '0');

        this.form.endDate = endDay + '/' + endMonth + '/' + endYear;
        this.endDatePickerValue = endYear + '-' + endMonth + '-' + endDay;
      }

      // Si es traslado de domicilio, la fecha fin es la misma que la de inicio (1 día)
      if (this.isTrasladoDomicilio) {
        this.form.endDate = day + '/' + month + '/' + year;
        this.endDatePickerValue = year + '-' + month + '-' + day;
      }

      // Si es permiso climático, ajustar automáticamente la fecha fin a 4 días después
      if (this.isPermisoClimatico) {
        const startDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        const endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + 3); // 3 días después (4 días en total incluyendo el día de inicio)

        const endYear = endDate.getFullYear();
        const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
        const endDay = String(endDate.getDate()).padStart(2, '0');

        this.form.endDate = endDay + '/' + endMonth + '/' + endYear;
        this.endDatePickerValue = endYear + '-' + endMonth + '-' + endDay;
      }

      // Si es deber inexcusable, funciones sindicales, nacimiento/cuidado menor o donación de órganos,
      // establecer fecha fin a 1 año después por defecto (indefinido)
      if (this.isDeberInexcusable || this.isFuncionesSindicales || this.isNacimientoCuidadoMenor || this.isDonacionOrganos) {
        const startDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        const endDate = new Date(startDate);
        endDate.setFullYear(endDate.getFullYear() + 1); // 1 año después

        const endYear = endDate.getFullYear();
        const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
        const endDay = String(endDate.getDate()).padStart(2, '0');

        this.form.endDate = endDay + '/' + endMonth + '/' + endYear;
        this.endDatePickerValue = endYear + '-' + endMonth + '-' + endDay;
      }
    },

    onEndDateSelected(date) {
      // date viene en formato YYYY-MM-DD del date picker
      // Convertir a DD/MM/YYYY
      const parts = date.split('-');
      const year = parts[0];
      const month = parts[1];
      const day = parts[2];
      this.form.endDate = day + '/' + month + '/' + year;
      this.endDatePickerMenu = false;

      // Limpiar error de validación si existe
      if (this.validationErrors.endDate) {
        this.validationErrors.endDate = '';
      }
    },

    showSnackbar(color, text) {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.visible = true;
    },

    cancel() {
      this.$emit("close", null);
    },

    async convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    async save() {
      // Limpiar errores previos
      this.validationErrors = {
        type: '',
        reason: '',
        startTime: '',
        endTime: '',
        date: '',
        endDate: '',
        fotoJustificante: ''
      };

      // Declarar reasonToValidate aquí para que esté disponible en todo el método
      const reasonToValidate = this.form.reason;

      // Validación para BAJAS (similar a vacaciones - no usa AbsenceValidator)
      if (this.isBaja || this.bajaMode) {
        // Validar tipo obligatorio
        if (!this.form.type) {
          this.validationErrors.type = 'Debe seleccionar un tipo de baja';
          this.showSnackbar('error', 'Debe seleccionar el tipo de baja');
          return;
        }

        // Validar fecha de inicio obligatoria
        const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
        if (!this.form.date) {
          this.validationErrors.date = 'Debe seleccionar día de inicio';
          this.showSnackbar('error', 'Debe seleccionar el día de inicio de la baja');
          return;
        } else if (!dateRegex.test(this.form.date)) {
          this.validationErrors.date = 'Formato inválido (DD/MM/YYYY)';
          this.showSnackbar('error', 'Formato de fecha inválido');
          return;
        }

        // Validar fecha de fin obligatoria
        if (!this.form.endDate) {
          this.validationErrors.endDate = 'Debe seleccionar día de fin';
          this.showSnackbar('error', 'Debe seleccionar el día de fin de la baja');
          return;
        } else if (!dateRegex.test(this.form.endDate)) {
          this.validationErrors.endDate = 'Formato inválido (DD/MM/YYYY)';
          this.showSnackbar('error', 'Formato de fecha inválido');
          return;
        }

        // Validar justificante obligatorio si es Baja
        if (!this.form.fotoJustificante) {
          this.validationErrors.fotoJustificante = 'El justificante es obligatorio para bajas';
          this.showSnackbar('error', 'Debe adjuntar un justificante PDF para la baja');
          return;
        }

        // Validar que fecha fin >= fecha inicio
        const startParts = this.form.date.split('/').map(Number);
        const startDateTemp = new Date(startParts[2], startParts[1] - 1, startParts[0], 0, 0, 0);

        const endParts = this.form.endDate.split('/').map(Number);
        const endDateTemp = new Date(endParts[2], endParts[1] - 1, endParts[0], 0, 0, 0);
        const endDateTempEnd = new Date(endParts[2], endParts[1] - 1, endParts[0], 23, 59, 59);

        if (endDateTemp < startDateTemp) {
          this.validationErrors.endDate = 'La fecha de fin debe ser posterior o igual a la de inicio';
          this.showSnackbar('error', 'La fecha de fin debe ser posterior o igual a la de inicio');
          return;
        }

        // Validación específica para baja de matrimonio (debe ser exactamente 15 días naturales)
        if (this.isMatrimonioBaja) {
          const diffTime = endDateTempEnd.getTime() - startDateTemp.getTime();
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 para incluir el día de inicio

          if (diffDays !== 15) {
            this.validationErrors.date = 'Debe ser exactamente 15 días naturales';
            this.validationErrors.endDate = 'Debe ser exactamente 15 días naturales';
            this.showSnackbar('error', 'La baja por matrimonio debe ser de exactamente 15 días naturales');
            return;
          }
        }

        // Validación específica para fallecimiento 1º grado (debe ser exactamente 4 días laborables)
        if (this.isFallecimiento1Grado) {
          const businessDays = this.countBusinessDays(startDateTemp, endDateTemp);

          if (businessDays !== 4) {
            this.validationErrors.date = 'Debe ser exactamente 4 días laborables';
            this.validationErrors.endDate = 'Debe ser exactamente 4 días laborables';
            this.showSnackbar('error', 'La baja por fallecimiento 1º grado debe ser de exactamente 4 días laborables');
            return;
          }
        }

        // Validación específica para fallecimiento 2º grado (debe ser exactamente 2 días laborables)
        if (this.isFallecimiento2Grado) {
          const businessDays = this.countBusinessDays(startDateTemp, endDateTemp);

          if (businessDays !== 2) {
            this.validationErrors.date = 'Debe ser exactamente 2 días laborables';
            this.validationErrors.endDate = 'Debe ser exactamente 2 días laborables';
            this.showSnackbar('error', 'La baja por fallecimiento 2º grado debe ser de exactamente 2 días laborables');
            return;
          }
        }

        // Validación específica para traslado de domicilio (debe ser exactamente 1 día)
        if (this.isTrasladoDomicilio) {
          const diffTime = endDateTemp.getTime() - startDateTemp.getTime();
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

          if (diffDays !== 1) {
            this.validationErrors.date = 'Debe ser exactamente 1 día';
            this.validationErrors.endDate = 'Debe ser exactamente 1 día';
            this.showSnackbar('error', 'La baja por traslado de domicilio debe ser de exactamente 1 día');
            return;
          }
        }

        // Validación específica para permiso climático (debe ser exactamente 4 días)
        if (this.isPermisoClimatico) {
          const diffTime = endDateTempEnd.getTime() - startDateTemp.getTime();
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

          if (diffDays !== 4) {
            this.validationErrors.date = 'Debe ser exactamente 4 días';
            this.validationErrors.endDate = 'Debe ser exactamente 4 días';
            this.showSnackbar('error', 'El permiso climático debe ser de exactamente 4 días');
            return;
          }
        }

        // Validar solapamiento con otras bajas
        for (const existingAbsence of this.existingAbsences) {
          // Solo validar contra otras bajas
          if (!existingAbsence.tipoAusencia || !existingAbsence.tipoAusencia.startsWith('Baja:')) {
            continue;
          }

          const existingStart = new Date(existingAbsence.start);
          const existingEnd = new Date(existingAbsence.end);

          // Verificar si hay solapamiento
          const hasOverlap = !(endDateTemp < existingStart || startDateTemp > existingEnd);

          if (hasOverlap) {
            this.validationErrors.date = 'Conflicto con otra baja';
            this.validationErrors.endDate = 'Conflicto con otra baja';
            this.showSnackbar('error', 'Ya tienes una baja solicitada para esos días');
            return;
          }
        }
      } else {
        // Validación para AUSENCIAS NORMALES (usa AbsenceValidator)
        const errors = AbsenceValidator.validate(
          {
            type: this.form.type,
            reason: reasonToValidate,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            date: this.form.date
          },
          this.existingAbsences
        );

        // Si hay errores, asignarlos y detener
        if (AbsenceValidator.hasErrors(errors)) {
          this.validationErrors = {
            type: errors.type || '',
            reason: errors.reason || '',
            startTime: errors.startTime || '',
            endTime: errors.endTime || '',
            date: errors.date || ''
          };

          // Mostrar mensaje específico según el tipo de error
          if (errors.startTime === 'Verifica las horas' || errors.endTime === 'La hora fin debe ser mayor que la hora inicio') {
            this.showSnackbar('error', 'Error: hora inicio no concuerda con hora fin');
          } else if (errors.startTime === 'Conflicto con otra ausencia') {
            this.showSnackbar('error', 'Ya tienes una ausencia para esos días');
          }

          return;
        }
      }

      // Crear objetos Date
      let startDate, endDate;

      if (this.isBaja) {
        // Para bajas, usar día completo (00:00 a 23:59) con fecha de inicio y fin
        const startParts = this.form.date.split('/').map(Number);
        startDate = new Date(startParts[2], startParts[1] - 1, startParts[0], 0, 0, 0);

        const endParts = this.form.endDate.split('/').map(Number);
        endDate = new Date(endParts[2], endParts[1] - 1, endParts[0], 23, 59, 59);

        // Validar que la fecha de fin sea mayor o igual a la de inicio
        if (endDate < startDate) {
          this.validationErrors.endDate = 'La fecha de fin debe ser posterior a la de inicio';
          this.showSnackbar('error', 'La fecha de fin debe ser posterior a la de inicio');
          return;
        }
      } else {
        // Para ausencias normales, usar el validador con horas
        const dates = AbsenceValidator.createDateObjects({
          type: this.form.type,
          reason: reasonToValidate,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          date: this.form.date
        });
        startDate = dates.startDate;
        endDate = dates.endDate;
      }

      // Convertir el archivo a base64 si existe
      let fotoJustificanteBase64 = null;
      if (this.form.fotoJustificante) {
        try {
          fotoJustificanteBase64 = await this.convertFileToBase64(this.form.fotoJustificante);
        } catch (error) {
          console.error("Error al convertir el archivo:", error);
          this.showSnackbar('error', 'Error al procesar el archivo PDF');
          return;
        }
      }

      // Usar el motivo adecuado (texto por defecto si es baja sin motivo)
      const finalReason = this.isBaja && !this.form.reason.trim()
        ? 'Baja laboral'
        : this.form.reason.trim();

      // Convertir a ISO string para enviar al backend
      const absence = new Absence(
        uuidv4(),
        startDate.toISOString(),
        endDate.toISOString(),
        finalReason,  // reason = texto libre o "Baja laboral" por defecto
        'pending',  // status por defecto
        fotoJustificanteBase64,  // Pasar el archivo en base64
        null,  // lista_motivos (no se usa)
        this.form.type  // tipoAusencia = tipo seleccionado del dropdown (ej: "Baja: Matrimonio")
      );

      this.$emit("close", absence);
    },

    openTimePicker(field) {
      this.currentTimeField = field;
      this.currentTimePicker = field === 'start' ? this.form.startTime : this.form.endTime;
      this.editandoHora = true;
    },

    cerrarEdicionHora() {
      if (this.currentTimeField === 'start') {
        this.form.startTime = this.currentTimePicker;
      } else {
        this.form.endTime = this.currentTimePicker;
      }
      this.editandoHora = false;
      this.currentTimeField = null;
    },

    cancelarEdicionHora() {
      this.editandoHora = false;
      this.currentTimeField = null;
      this.currentTimePicker = "";
    },

    validateTime(field) {
      const timeRegex = /^([0-1]?\d|2[0-3]):?([0-5]?\d)?$/;
      if (timeRegex.test(this.form[field])) {
        if (this.errors && this.errors[field]) {
          const newErrors = Object.assign({}, this.errors);
          delete newErrors[field];
          this.$emit('update-errors', newErrors);
        }
      }
    },

    validateDate() {
      const dateRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
      if (dateRegex.test(this.form.date)) {
        if (this.errors && this.errors.date) {
          const newErrors = Object.assign({}, this.errors);
          delete newErrors.date;
          this.$emit('update-errors', newErrors);
        }
      }
    },

    showErrorDialog(message, details = '') {
      this.errorDialog.message = message;
      this.errorDialog.details = details;
      this.errorDialog.show = true;

      // Si el error es de conflicto con otra ausencia, marcar campos de hora en rojo
      if (message && (message.includes('Conflicto') || message.includes('solapa') || message.includes('existe una ausencia'))) {
        this.validationErrors.startTime = "Conflicto con otra ausencia";
        this.validationErrors.endTime = "Conflicto con otra ausencia";
        this.showSnackbar('error', 'Error: conflicto con otra ausencia registrada');
      }
    },
  },
};
</script>

<style scoped>
.btn-cancelar-flotante {
  position: absolute;
  right: 10px;
  top: 10px;
}

.header-separator {
  margin: 0 20px 10px;
  border: none;
  border-top: 1px solid #ccc;
}

.campo-label {
  font-weight: 600;
  margin-bottom: 6px;
  color: #333;
}

.campo-label-compacto {
  margin-bottom: 4px;
}

.campo-compacto {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.campo-compacto .v-input__control {
  min-height: 40px !important;
}

.required-asterisk {
  color: #d32f2f;
  font-weight: bold;
  margin-left: 2px;
}

.info-dias-baja {
  color: #888;
  font-size: 12px;
  font-style: italic;
  margin-top: 8px;
  margin-bottom: 8px;
  padding-left: 4px;
}

.campo-redondeado .v-input__control {
  border-radius: 12px;
  background-color: var(--v-neutral-base);
}

.campo-indefinido input {
  font-style: italic;
  color: #888 !important;
}

.campo-error .v-input__control {
  border: 2px solid #d32f2f !important;
  background-color: #ffebee !important;
}

.campo-error .v-input__slot {
  border: 2px solid #d32f2f !important;
}

.v-messages.error--text {
  color: #d32f2f !important;
  font-size: 12px;
  margin-top: 4px;
  font-weight: 500;
}

.btn-fondo {
  background: var(--Primary-700, #7339B7)!important;
  color: white;
  text-transform: none;
  font-weight: 600;
  margin-bottom: 30px;
}

.btn-fondo:hover {
  background-color: #7a66d9;
}

.btn-fondo1 {
  background-color: #FFFFFF !important;
  color: #7339B7 !important;
  padding: 6px 16px !important;
  min-width: 120px !important;
  text-align: center !important;
  font-family: Roboto !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal !important;
  border: 1px solid #7339B7 !important;
  border-radius: 8px !important;
}

.modo-edicion-hora {
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
}

.rectangulo-edicion {
  width: 100%;
  max-width: 700px;
  box-sizing: border-box;
  padding: 16px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.hora-body {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  overflow: hidden;
  margin-bottom: 20px;
}

.selector-hora {
  width: 100%;
  max-width: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<style>
/* Estilos globales para el time picker */
.selector-hora .v-picker {
  background-color: transparent !important;
  box-shadow: none !important;
}

.selector-hora .v-time-picker-title {
  background-color: transparent !important;
  box-shadow: none !important;
}

.selector-hora .v-time-picker-clock {
  width: 280px;
  height: 280px;
  border-radius: 50%;
  background: transparent !important;
}

.selector-hora .v-time-picker-clock__container {
  background: transparent !important;
}

.selector-hora .v-time-picker-title__time {
  font-size: 14px !important;
  padding: 4px 8px !important;
  border-radius: 8px !important;
  gap: 2px !important;
  border: 1px solid #ccc !important;
  background-color: #9F6BE1 !important;
  color: white !important;
}

.selector-hora .v-time-picker-clock__hand,
.selector-hora .v-time-picker-clock__center,
.selector-hora .v-time-picker-clock__item--active {
  background-color: #9F6BE1 !important;
}

.selector-hora .v-picker__title,
.selector-hora .v-time-picker-title {
  background: transparent !important;
  box-shadow: none !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.selector-hora .v-picker__title__btn,
.selector-hora .v-picker__title__btn.v-picker__title__btn--active,
.selector-hora .v-picker__title__btn:hover,
.selector-hora .v-picker__title__btn:focus {
  background: transparent !important;
  box-shadow: none !important;
  color: #333 !important;
}

.selector-hora .v-picker__body {
  background: transparent !important;
}

/* Estilos del dialog de error */
.error-dialog-header {
  background-color: #d32f2f !important;
  color: white !important;
  padding: 20px 24px !important;
}

.error-dialog-title {
  color: white !important;
  font-size: 20px !important;
  font-weight: 600 !important;
}

.error-dialog-content {
  padding: 32px 24px !important;
  text-align: center;
}

.error-icon-wrapper {
  margin-bottom: 20px;
}

.error-message {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  line-height: 1.5;
}

.error-details {
  font-size: 14px;
  color: #666;
  margin-top: 8px;
  line-height: 1.6;
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 8px;
  border-left: 4px solid #d32f2f;
}

.error-dialog-actions {
  padding: 16px 24px !important;
  background-color: var(--v-neutral-base) !important;
}
</style>